module.exports = __webpack_public_path__ + "img/metro_L10S.66f7ccaa.svg";